/**
 * How the rest of the kitchen screen nudges the orders sync (feature 334).
 *
 * Socket events, order actions and socket (re)connects must not each hold a
 * reference to the sync loop: they call these two functions, and whichever loop
 * is running answers. With no loop running they do nothing, which is the right
 * answer on screens that do not show the order board.
 */

export interface SyncHandlers {
  /** Poll the changes feed now instead of waiting for the next tick. */
  pollNow(): void;
  /** Read the whole list again (resync): socket (re)connect, unknown state. */
  reloadAll(): void;
}

const handlers = new Set<SyncHandlers>();

/** Called by the running sync loop. Returns the unsubscribe. */
export function registerSyncHandlers(h: SyncHandlers): () => void {
  handlers.add(h);
  return () => {
    handlers.delete(h);
  };
}

/** True when a loop took the request. */
export function requestFeedPoll(): boolean {
  for (const h of handlers) h.pollNow();
  return handlers.size > 0;
}

/** True when a loop took the request. */
export function requestFullReload(): boolean {
  for (const h of handlers) h.reloadAll();
  return handlers.size > 0;
}
